module.exports = __webpack_public_path__ + "img/gsm_cover.6ee5ad4c.png";